import React from "react";

export const PseudoRadio = ({ condition, bgCol }) => {
  return (
    <div
      className="position-absolute mt-1 rounded-circle"
      style={{
        width: "14px",
        height: "14px",
        border: `1px solid ${condition ? bgCol : "#d2d2d2"}`,
        padding: "1.9px",
      }}
    >
      <div
        className="w-100 h-100 rounded-circle"
        style={{ background: condition ? bgCol : "transparent" }}
      ></div>
    </div>
  );
};
